/* Isolated progressive enhancement; native contact submission remains untouched. */
(() => {
  'use strict';
  document.querySelectorAll('[data-hc-experience]').forEach(root => {
    if (root.dataset.hcReady) return;
    root.dataset.hcReady = 'true';
    const select = root.querySelector('#hc-topic');
    const tabs = [...root.querySelectorAll('[data-hc-topic]')];
    const panels = [...root.querySelectorAll('[data-hc-guide]')];
    const tablist = root.querySelector('[data-hc-tabs]');
    if (select && tabs.length === 4 && panels.length === 4 && tablist) {
      const activate = value => {
        if (!tabs.some(tab => tab.dataset.hcTopic === value)) value = 'project';
        select.value = value;
        tabs.forEach(tab => {
          const active = tab.dataset.hcTopic === value;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.hcGuide !== value;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', 'hc-tab-' + panel.dataset.hcGuide);
        });
      };
      root.classList.add('hc-enhanced');
      tablist.hidden = false;
      activate(select.value);
      select.addEventListener('change', () => activate(select.value));
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab.dataset.hcTopic));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            activate(tabs[next].dataset.hcTopic);
            tabs[next].focus();
          }
        });
      });
    }
    const control = root.querySelector('[data-hc-motion]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    const update = () => {
      root.classList.toggle('hc-paused', userPaused || reduced.matches);
      if (control) {
        control.hidden = reduced.matches;
        control.textContent = userPaused ? control.dataset.resume : control.dataset.pause;
      }
    };
    control?.addEventListener('click', () => { userPaused = !userPaused; update(); });
    reduced.addEventListener('change', update);
    document.addEventListener('visibilitychange', () => root.classList.toggle('hc-inactive', document.hidden));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        root.classList.toggle('hc-inactive', !entries[0].isIntersecting || document.hidden);
      });
      observer.observe(root.querySelector('.hc-console'));
    }
    update();
    const status = root.querySelector('#hc-status');
    if (status) status.focus({ preventScroll: false });
    addEventListener('pageshow', () => { if (select && tablist && !tablist.hidden) select.dispatchEvent(new Event('change')); });
  });
})();
